<template>
  <div class="flex justify-between border d-theme-dark-bg items-center h-16">
    <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" :placeholder="searchString ? '' : $t('fields.search')"
              v-model="searchString" @keyup.enter="search()"
              class="vs-input-no-border vs-input-no-shdow-focus w-full" ref="searchInput"/>

    <feather-icon class="ml-4 mr-4 cursor-pointer" icon="SearchIcon" @click="search()" v-if="showSearchIcon"/>
    <feather-icon class="ml-4 mr-4 cursor-pointer" icon="XIcon" @click="clear()" v-if="!showSearchIcon"/>
  </div>
</template>

<script>
export default {
  name: "GoogleFy",
  emits: ['clear-search', 'search'],
  props: {
    queriedString: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      searchString: null,
    }
  },
  computed: {
    showSearchIcon() {
      if (this.searchString === this.queriedString && this.searchString === null) {
        return true;
      } else if (this.searchString !== this.queriedString) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    clear() {
      this.$emit('clear-search');
      this.searchString = null;
    },
    search() {
      this.$emit('search', this.searchString);
    },
  },
  mounted() {
    console.log('Mounting google-fy ', this.queriedString, this.searchString);
  }
}
</script>

<style scoped>

</style>
